// 서비스 파일 구조

import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";

/*
 * Customs employee change history service
 * !== 세관직원변경이력 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/usr/ofcrhist`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/cstm-ofcr-hist`,
    nodes: [
        { path: "/", label: "L_INT_PTL" },
        { path: "/", label: "L_PTL_MGMT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0904001q: `${BASE.path}/ptli0904001q`, // Customs employee change history list !== 세관직원변경이력 목록 ==!
    ptli0904002q: `${BASE.path}/ptli0904002q`, // Detailed list of customs employee change history !== 세관직원변경이력 상세 목록 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Inquiry into detailed information of customs employee application !== 세관직원변경이력 조회==!
    getCstmOfcrChgHistList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Customs details inquiry !== Customs employee change history details inquiry ==!
    getCstmOfcrChgHistDtl: (usrDmnId: any) => {
        return api.get(`${BASE.api}/${usrDmnId}`);
    },
    // Detailed list of customs employee change history !== 세관직원변경이력 상세 목록 ==!
    getCstmOfcrChgHistDtlList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}/${data.usrDmnId}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Get a excel list of Customs staff. !== 세관 직원 엑셀 목록을 조회한다. ==!
    getCstmOfcrChgHistExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),
};

export const SF_CSTM_OFCR_CHG_HIST_SRCH: TFormSchema = {
    id: "form_CstmOfcrChgHist",
    schema: {
        usrNm: { type: "text", label: "L_NM" },
        usrDmnId: { type: "text", label: "L_USR_ID" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        cstmOfceCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd", popupSize: "md" },
        // cstmSctnCd: { type: "select", label: "L_CSTM_SCTN", area: "comnCd", comnCd: "PTL0003" },
        usrStatCd: { type: "checkbox", label: "L_USR_STAT", area: "comnCd", comnCd: "PTL0001" },
        cstmSctnCd: { type: "code", label: "L_CSTM_SCTN", area: "cstmOrgzCd" },
        cstmUnitCd: { type: "code", label: "L_CSTM_UNIT", area: "cstmOrgzCd" },
    },
};

export const SG_CSTM_OFCR_CHG_HIST_LIST: TGridSchema = {
    id: "grid_CstmOfcrChgHistList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "10%" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: "10%" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "15%" }] },
        { cells: [{ header: "L_CSTM_SCTN", binding: "cstmSctnCdNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE", binding: "cstmOfceCdNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_UNIT", binding: "cstmUnitCdNm", width: "12%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "8%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "12%" }] },
    ],
    body: [
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrHistCnt", align: "right", type: "number" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "cstmSctnCdNm", align: "left" }] },
        { cells: [{ binding: "cstmOfceCdNm", align: "left" }] },
        { cells: [{ binding: "cstmUnitCdNm", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm", align: "left" }] },
        { cells: [{ binding: "lastMdfrId", align: "left" }] },
        { cells: [{ binding: "lastMdfyDtm", type: "datetime" }] },
    ],
};

export const SG_CSTM_OFCR_CHG_HIST_DTL_LIST: TGridSchema = {
    id: "grid_CstmOfcrChgHistDtlList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: "10%" }] },
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_CSTM_USR_TIN", binding: "usrTin", width: "10%" }] },
        { cells: [{ header: "L_CSTM_USR_TELNO", binding: "usrTelno", width: "15%" }] },
        { cells: [{ header: "L_CSTM_USR_EML_ADDR", binding: "usrEmlAddr", width: "20%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_CSTM_OFCE", binding: "cstmOfceCdNm", width: "20%" }] },
        { cells: [{ header: "L_CSTM_SCTN", binding: "cstmSctnCdNm", width: "20%" }] },
        { cells: [{ header: "L_CSTM_USR_VLD_STRT_DT", binding: "vldStrtDt", width: "10%" }] },
        { cells: [{ header: "L_CSTM_USR_VLD_END_DT", binding: "vldEndDt", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        {
            cells: [{ binding: "usrNm", align: "left" }],
        },
        {
            cells: [{ binding: "usrTin" }],
        },
        {
            cells: [{ binding: "usrTelno" }],
        },
        {
            cells: [{ binding: "usrEmlAddr", align: "left" }],
        },
        {
            cells: [{ binding: "usrStatCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmOfceCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "cstmSctnCdNm", align: "left" }],
        },
        {
            cells: [{ binding: "vldStrtDt" }],
        },
        {
            cells: [{ binding: "vldEndDt" }],
        },
        {
            cells: [{ binding: "lastMdfrId", align: "left" }],
        },
        {
            cells: [{ binding: "lastMdfyDtm" }],
        },
    ],
};

export const SG_CSTM_OFCR_CHG_HIST_EXCEL_LIST: TGridSchema = {
    id: "grid_CstmOfcrChgHistExcelList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_NM", binding: "usrNm", width: "15%" }] },
        { cells: [{ header: "L_USR_HIST_CNT", binding: "usrHistCnt", width: "10%" }] },
        { cells: [{ header: "L_USR_ID", binding: "usrDmnId", width: "10%" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "15%" }] },
        { cells: [{ header: "L_CSTM_SCTN", binding: "cstmSctnCdNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_OFCE", binding: "cstmOfceCdNm", width: "*" }] },
        { cells: [{ header: "L_CSTM_UNIT", binding: "cstmUnitCdNm", width: "12%" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "8%" }] },
        { cells: [{ header: "L_LAST_MDFR_ID", binding: "lastMdfrId", width: "10%" }] },
        { cells: [{ header: "L_LAST_MDFY_DTM", binding: "lastMdfyDtm", width: "12%" }] },
    ],
    body: [
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrHistCnt", align: "right", type: "number" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "cstmSctnCdNm", align: "left" }] },
        { cells: [{ binding: "cstmOfceCdNm", align: "left" }] },
        { cells: [{ binding: "cstmUnitCdNm", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm", align: "left" }] },
        { cells: [{ binding: "lastMdfrId", align: "left" }] },
        { cells: [{ binding: "lastMdfyDtm", type: "datetime" }] },
    ],
};
